<div>
  <div *ngIf="!showUserForm">
  <c-smart-table [columnSorter]="true" [columns]="columns" [columnFilter]="true" [itemsPerPageSelect]="true"
    [itemsPerPage]="10" [items]="RetailCustomerTable" [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }" header pagination>
  
   <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
            <td>
                <ng-container [ngSwitch]="columnName">
                   
                    <ng-container *ngSwitchCase="'raisedBy'">
                        <button cButton style="text-wrap-mode: nowrap;" size="sm"
                            (click)="viewClassification(item)">{{'View'}}</button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{tdContent}}
                    </ng-container>
                </ng-container>
            </td>
        </ng-template>
  
  </c-smart-table>
  </div>


  <div *ngIf="showUserForm" style="margin-top:0px;padding: 32px;">
        <!-- <div class="section-title">Customer Details</div> -->
<form cForm [formGroup]="userForm" class="needs-validation" [gutter]="3" novalidate>
  
  <div class="row">
    <div class="col-4">
      <label cLabel for="inputCIF">CIF</label>
      <input cFormControl id="inputCIF" type="text" formControlName="customerCIF" readonly />
    </div>
     <div class="col-4">
      <label cLabel for="inputName">Customer Name</label>
      <input cFormControl id="inputName" type="text" formControlName="customerName" readonly />
    </div>
  </div>

  <div class="row pt-2">
    <div class="col-4">
      <label cLabel for="inputNetAssets">Net Assets</label>
      <input cFormControl id="inputNetAssets" type="text" formControlName="netAssets" readonly />
    </div>
    <div class="col-4">
      <label cLabel for="inputEmploymentType">Employment Type</label>
      <input cFormControl id="inputEmploymentType" type="text" formControlName="employmentType" readonly />
    </div>
  </div>

  <div class="row pt-2">
    <div class="col-4">
      <label cLabel for="inputPrimaryIncomeRange">Primary Income Range (Per Annum)</label>
      <input cFormControl id="inputPrimaryIncomeRange" type="tel" formControlName="primaryIncomeRange" readonly />
    </div>
    <div class="col-4">
      <label cLabel for="inputOtherIncomeRange">Other Income Range (Per Annum)</label>
      <input cFormControl id="inputOtherIncomeRange" type="tel" formControlName="otherIncomeRange" readonly />
    </div>
  </div>

  <!-- Section: Documents Uploads -->
<div class="row pt-4">
  <div class="section-title mb-3" style="font-size: 20px;font-weight: 600;padding: 20px 12px;">Documents Uploads</div>

  <!-- Generic block to render document sections -->
  <ng-container *ngFor="let docGroup of documentGroups">
    <div class="col-12" *ngIf="docGroup.docs.length">
      <h6 style="padding: 15px 0;">{{ docGroup.label }}</h6>
      <div class="row">
        <div class="col-4" *ngFor="let doc of docGroup.docs">
          <button (click)="downloadDocument(doc)" class="btn btn-light d-flex align-items-center justify-content-between w-100 mb-2">
            <div class="d-flex align-items-center gap-2">
              <i [ngClass]="getFileIconClass(doc.documentName)" class="me-2"></i>
              <span>{{ truncateFileName(doc.documentName, 20, 15) }}</span>
            </div>
            <i class="doc-arrow"></i> <!-- Font Awesome arrow icon -->
          </button>
        </div>
      </div>
      <hr>
    </div>
  </ng-container>
</div>

  <!-- Action Buttons -->
  <div class="row pt-4 pb-4">
    <div class="col-12 d-flex gap-24" style="justify-content: flex-end;gap: 20px;">
      <button cButton color="light" size="lg" type="button" (click)="resetForm()">Close</button>
    </div>
  </div>

</form>


        <!-- <form cForm [formGroup]="userForm" class="needs-validation" [gutter]="3" novalidate>
            <div class="row">
                <div class="col-6">
                    <label cLabel for="inputCIF">CIF</label>
                    <input cFormControl id="inputCIF" type="text" formControlName="customerCIF"/>
                  </div>
            </div>
            <div class="row">              
              <div class="col-6">
                <label cLabel for="inputName">Full Name</label>
                <input readonly cFormControl id="inputName" type="text" formControlName="customerName" />
              </div>
              <div class="col-6">
                <label cLabel for="inputEmail">Email</label>
                <input readonly cFormControl id="inputEmail" type="email" formControlName="customerEmail" />
              </div>
            </div>
            <div class="row pt-2">              
              <div class="col-6">
                <label cLabel for="inputMobileNumber">Mobile Number</label>
                <input readonly cFormControl id="inputMobileNumber" type="tel" formControlName="customerMobile" />
              </div>
              <div class="col-6">
                <label cLabel for="ddlClientCategory">Client Category</label>
                <select cSelect id="ddlClientCategory" name="clientCategory" formControlName="clientCategory">
                    <option value="">Select</option>
                    <option value="RETAIL.CLIENT">Retail Client</option>
                    <option value="PROFESSIONAL.CLIENT">Professional Client</option>                    
                </select>
              </div>
             
            </div>
          <div class="row pt-2"> 
            <div class="section-title">Documents</div>
                <div class="col-4" *ngFor="let doc of documents">
                  
                    <button (click)="downloadDocument(doc)"   class="btn btn-default w-100 mb-2">
                    {{ doc.documentName }}
                    </button>
               
                </div> 
          </div>
  
            <div class="row" style="margin-top: 32px;padding-bottom:32px;">
                <div class="col-6 d-flex gap-24">
                    <button cButton color="light" size="lg" type="button" (click)="resetForm()">
                        Reset
                    </button>
                    <button cButton color="primary" size="lg" type="submit" (click)="onUserFormSaveClick();">
                        Save
                    </button>
                </div>                
            </div>
          </form> -->
    </div>

</div>